import React from 'react';
import PropTypes from 'prop-types';
import { formatInTimeZone } from 'date-fns-tz';
import { PARIS_TIMEZONE, toParisTime } from '../../../../../../../../../../shared/utils/formattedDates';

import { Event } from '../../../Event';

export const Events = ({ events, referenceDate, handleEventOpen, handleEventUpdate, handleEventDelete }) => {
  const setGridRow = (startRaw, endRaw) => {
    const start = new Date(startRaw);
    const end = new Date(endRaw);

    const diffMinutes = (end.getTime() - start.getTime()) / 60000;
    const span = Math.round(diffMinutes / 15);

    const [hStr, mStr] = formatInTimeZone(start, PARIS_TIMEZONE, 'HH:mm').split(':');
    const h = parseInt(hStr, 10);
    const m = parseInt(mStr, 10);

    const startInMinutes = (h - 7) * 60 + m;
    const startLine = Math.round(startInMinutes / 15) + 1;

    return `${startLine} / span ${span > 3 ? span : 3}`;
  };

  const setColStart = (date) => {
    const dateBeginningOfDay = toParisTime(date).setHours(0,0,0,0)
    const referenceDateBeginningOfDay = toParisTime(referenceDate).setHours(0,0,0,0)
    const diffDays = Math.round((dateBeginningOfDay - referenceDateBeginningOfDay) / 86400000);

    switch (diffDays) {
      case 0: return 'col-start-1';
      case 1: return 'col-start-2';
      case 2: return 'col-start-3';
      case 3: return 'col-start-4';
      case 4: return 'col-start-5';
      case 5: return 'col-start-6';
      case 6: return 'col-start-7';
      default: return 'hidden'
    }
  }

  const setZindex = (event) => {
    switch (event.typeSlug) {
      case 'visit':
        return 'z-30';
      default:
        return 'z-20'
    }
  }

  const handleClick = (event) => {
    if (!event.clickable) return;

    if (event.typeSlug === 'visit') {
      handleEventOpen(event);
    } else if (event.typeSlug === 'indispo') {
      handleEventUpdate(event)
    }
  }

  return (
    <>
      {events.map((event) => {
        return (
          <li key={event.id} onClick={() => handleClick(event)} className={`${setColStart(event.start)} relative flex ${setZindex(event)} ${event.clickable ? 'cursor-pointer' : ''}`} style={{ gridRow: setGridRow(event.start, event.end) }}>
            <Event event={event} handleEventDelete={handleEventDelete} />
          </li>
        )
      })}
    </>
  )
}

Events.propTypes = {
  events: PropTypes.array,
  referenceDate: PropTypes.object,
  handleEventOpen: PropTypes.func,
  handleEventUpdate: PropTypes.func,
  handleEventDelete: PropTypes.func
};
